module.exports = new __parcel__URL__("Prodigy_Health.ee1cfb95.png").toString();